<template>
  <div class="news-wrap">
    <div>
      <div class="bannerbox">
        <div class="banner">
          <img
            style="width: 100%; height: auto"
            src="@/assets/imgs/academic.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="newsbox">
        <div
          class="clearfix wrap"
          style="padding-top: 60px; padding-bottom: 60px"
        >
          <div class="menutitle">
            <el-breadcrumb separator-class="el-icon-arrow-right">

              <el-breadcrumb-item :to="{ path: '/exchange' }"
                >学术交流</el-breadcrumb-item
              >
              <el-breadcrumb-item>学术研究</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="newscontent"  @scroll="handleScroll($event)">
            <ul class="newslist" >
              <li v-for="inf in informationData" :key="inf.data">
                <div class="newstit">
                  <h3 :title="inf.title">
                    {{ inf.title }}
                    <!-- <a href="javascript:void(0)" :title="inf.title"></a> -->
                    <!-- <span>{{ inf.title }}</span> -->
                  </h3>
                  <span
                    >发布日期：{{ inf.publishTime }} 浏览次数: {{
                      inf.viewCount
                    }}次</span
                  >
                  <p v-html="inf.content"></p>
                  <button class="more" @click="go(inf)">了解更多</button>
                </div>

              </li>
            </ul>
              <div class="load" v-if="nextFlag">
                    <a-spin v-if="tipMessage != '数据已加载完!'"/><span class="load-text">{{tipMessage}}</span>
                </div>
                <div v-if="finalFlag" class="load">
                      <span class="load-text">{{tipMessage}}</span>
                </div>
          </div>
          <rigthBox
            :list="rigthBoxData"
            :sidebarTitle="sidebarTitle"
          ></rigthBox>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import rigthBox from "@/components/rigthBox";
export default {
  components: {
    rigthBox,
  },
  data() {
    return {
            page: {
        pageNum: 1,
        pageSize: 5,
      },
      nextFlag:true,
      finalFlag:false,
            tipMessage:'努力加载中...',
      sidebarTitle: "学术交流",
      rigthBoxData: [
        {
          name: "学术研究",
          index: "menu1",
          path: "/study",
          children: [],
        },
        {
          name: "学术活动",
          index: "menu2",
          path: "/activities",
          children: [],
        },
      ],
      informationData: [],
      win: "",
    };
  },
  mounted() {
    // var that = this;
    // console.log("this", this);
    // this.$axios.get("/frontapi/academic/study/list").then(
    //   function (res) {
    //     console.log(res);
    //     that.informationData = res.data.rows;
    //   },
    //   function () {
    //     console.log("请求失败");
    //   }
    // );
    // this.win = window.location.hash.split("/")[1];
    // console.log(this.win, "aaaa");
    this.getList();
  },
  methods: {
    go(val) {
      this.$router.push({ path: "/exchangeDetail", query: { id: val.id } });
    },
      handleScroll (event) {
        console.log(123232323);
        let Scroll = event.target;
        //滚动条到底部的条件
        if(Scroll.scrollTop +Scroll.clientHeight == Scroll.scrollHeight && !this.nextFlag && !this.finalFlag){
        this.nextFlag = true;
        this.page.pageNum++;
        setTimeout(()=>{ this.getList();},1000);

        }
	},
  getList()
  {
        var that = this;
        this.$axios.get("/frontapi/academic/study/list",
        {
               params:{
                   pageNum: this.page.pageNum,
                   pageSize: this.page.pageSize
               }
           }
        ).then(
          function(res) {
            console.log(res);
             that.informationData=[... that.informationData,...res.data.rows]
            if (res.data.rows.length == 0)
            {
              that.tipMessage = '数据已加载完!'
               that.finalFlag = true;
            }
          that.nextFlag = false;
           that.win = window.location.hash.split("/")[1];

          },
          function() {
            // console.log("请求失败");
          }
        );
  },
  },
  //   watch:{
  //   win:function(n){
  //       switch(n){
  //         case 'exchange' :
  //         document.querySelector('isActive').classList.add('is-active')
  //         break;

  //       }
  //   }
  // }
};
</script>
<style scoped>
::v-deep .mapTipWindow li {
    font-size: 18px;
}
img {
    font-size: 18px;
}
* {
  margin: 0;
  padding: 0;
}
.news-wrap {
  width: 100%;
   padding-top: 1.111111rem /* 80px -> 1.111111rem */;
  height: 100%;
    background-color: #f4f4f4;
}
.wrap {
  margin: 0 auto;
  width: 1200px;
  background: #f4f4f4;
}
.banner {
   height: auto;
  width: 100%;
}
.newsbox {
  background: #f4f4f4;
}
.clearfix:after {
  display: block;
  content: "";
  overflow: hidden;
  clear: both;
  height: 0;
}
.news-wrap >>> .menutitle {
  cursor: pointer;
}
.news-wrap >>> .is-link {
  font-weight: 400;
  color: #606266;
  cursor: pointer;
}
.menutitle >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  font-weight: 700;
  color: #303133;
  cursor: pointer;
}
.newscontent {
    padding: 0 30px;
  width: 860px;
  height: 1120px;
  background: #ffffff;
  float: left;
  margin-top: 40px;
  border-radius: 10px;
  overflow: scroll;
}
.newscontent::-webkit-scrollbar {
  display: none;
}
.newslist {
   width: 100%;
}
.newslist li {
  width: 100%;
  padding-top: 30px;

}
.newstit {
  width: 100%;
  height: 244px;
  border-bottom: 1px solid #eeeeee;
}
.newslist img {
  float: left;
  width: 200px;
  height: 260px;
}
.newstit h3 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
    width: 100%;
  height: 25px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  line-height: 25px;
}
/* .newstit h3 a{
  width: 90%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #222222;
  cursor:default;
} */
.newstit span {
    display: block;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #666666;
 height: 14px;
 margin: 20px 0 10px;
}
.newstit>p {

  text-overflow: ellipsis;
  word-break:break-all;
   height: 114px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  line-height: 24px;
    overflow: hidden;
    display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 5;
}
.newstit .more {
  float: right;
  width: 150px;
  height: 30px;
  border: 1px solid #b78c0d;
  border-radius: 3px 3px 3px 3px;
  background: #fff;
  font-size: 14px;
  color: #b78c0d;
  margin-top: 12px;
  cursor: pointer;
}
.load {
  display: flex;
  width: 100%;
  height: 40px;
  align-items: center;
  justify-content: center;
  transition: all 2s;
}
::v-deep .ant-spin-dot-item {
  background-color: #b78c0d;
  /* color: #b78c0d; */
}
.load-text {
  margin-left: 10px;
  font-size: 14px;
}
</style>
